<!--
  A circular loading indicator, used to display feedback when loading data.
-->
<template>
  <XIcon name="loading" class="loading-indicator opacity-50"/>
</template>
